/**
 * Google Search Console OAuth configuration.
 *
 * Two deliberate differences from the older Google integrations in this codebase:
 *
 *  1. There is no client *secret* here. The authorization code is exchanged by the
 *     backend (POST /{customer_id}/gsc/exchange-token), so no Google credential is
 *     ever shipped in the bundle — unlike gmbAuthentication.ts / youtubeAuthentication.ts,
 *     which still exchange in the browser.
 *  2. Search Console has its own OAuth client rather than reusing
 *     REACT_APP_GOOGLE_CLIENT_ID. Google merges previously-granted scopes per client
 *     and rejects some combinations outright, and an isolated client guarantees
 *     prompt=consent reissues a refresh token even for a user who already authorised
 *     Drive or GMB on the shared one.
 */

/** Read-only is all the planned reporting needs; do not widen without a reason. */
export const GSC_SCOPE = "https://www.googleapis.com/auth/webmasters.readonly";

export function getGscOAuthClientId(): string | undefined {
  return process.env.REACT_APP_GSC_CLIENT_ID?.trim() || undefined;
}

/**
 * Computed rather than configured, so a new deployment origin needs no extra env var
 * (same approach as getGoogleDriveOAuthRedirectUri). The exact string is sent to the
 * backend in the exchange body and must also be registered on the Google OAuth client.
 */
export function getGscOAuthRedirectUri(): string {
  return `${window.location.origin}/connect/gsc/callback`;
}

/**
 * When false the Connect card is not rendered at all: a card that can only produce an
 * OAuth error is worse than no card. Set REACT_APP_GSC_ENABLED=false to force off.
 */
export function isGscConfigured(): boolean {
  if (process.env.REACT_APP_GSC_ENABLED === "false") {
    return false;
  }
  return Boolean(getGscOAuthClientId());
}
